module.exports = __webpack_public_path__ + "img/USDT.51015086.png";